export default [
  {
    path: '/sell/:key?',
    name: 'sellPage',
    component: () => import(/*webpackChunkName:'sell'*/ '@/views/sell/index.vue'),
    meta: {},
  },
];
